<template>
	<p class="cms-post-excerpt" :style="{ textAlign: align || 'left' }">{{ excerpt }}</p>
</template>

<script>
/**
 * PostExcerptBlock.vue
 * ────────────────────
 * The article summary as a lead paragraph (standfirst), for Article templates.
 * Reads the post as the other Post blocks do (blocks/shared/postContext.js).
 */
import { resolvePost } from '@/websites/cms/blocks/shared/postContext.js';

export default {
	name: 'PostExcerptBlock',

	inject: {
		cmsPostPreview: { default: null }
	},

	props: {
		align: { type: String, default: 'left' },
		post: { type: Object, default: null }
	},

	computed: {
		excerpt: function () {
			return resolvePost(this.post, this.cmsPostPreview).websitePostExcerpt || '';
		}
	}
};
</script>

<style scoped>
.cms-post-excerpt {
	margin: 0;
	font-size: 1.2em;
	line-height: 1.5;
	color: var(--site-body-color, #5b6472);
	max-width: 100%;
	text-wrap: pretty;
}
</style>
